/** Mutuo accepts a shorter number than Prestito and CdQ do. */
export const LEAD_TASSO_PHONE_PATTERN = /^\d{5,15}$/;

const LEAD_TASSO_MIN_AMOUNT = 30_000;
const LEAD_TASSO_MAX_AMOUNT = 10_000_000;

/**
 * A parsed whole-euro amount (`null` when not a positive integer) in the
 * public cerca-mutuo funnel's €30.000–€10.000.000 range.
 */
export const leadTassoAmountRule = (amount: number | null) => {
  if (amount === null) return 'Inserisci un importo positivo in euro interi';
  return amount >= LEAD_TASSO_MIN_AMOUNT && amount <= LEAD_TASSO_MAX_AMOUNT
    ? true
    : "L'importo deve essere tra €30.000 e €10.000.000";
};

/** 100% of the property value is allowed, as in the public funnel. */
export const leadTassoLoanToValueRule = (
  loanAmount: number,
  propertyValue: number | null
) =>
  propertyValue === null || loanAmount <= propertyValue
    ? true
    : "L'importo richiesto non può superare il valore dell'immobile";
